import { render, staticRenderFns } from "./DosMediaU6.vue?vue&type=template&id=4b457fce&scoped=true&"
import script from "./DosMediaU6.vue?vue&type=script&lang=js&"
export * from "./DosMediaU6.vue?vue&type=script&lang=js&"
import style0 from "./DosMediaU6.vue?vue&type=style&index=0&id=4b457fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b457fce",
  null
  
)

export default component.exports